import { FC } from 'react';

type AvailableRangesSkeletonProps = {
  rangesCount: number;
};

const AvailableRangesViewTableSkeleton: FC<AvailableRangesSkeletonProps> = ({
  rangesCount,
}) => (
  <tbody>
    <tr>
      {Array.from({ length: rangesCount }).map((_, index) => (
        <td
          // eslint-disable-next-line react/no-array-index-key
          key={`range-placeholder-${index}`}
          className="badge placeholder ml-1 align-items-center col-2 h-20px"
        >
          <span />
          &nbsp;-&nbsp;
          <span />
          &nbsp;
        </td>
      ))}
    </tr>
  </tbody>
);

export default AvailableRangesViewTableSkeleton;
